<template>
  <v-sheet width="300px">
    <canvas :id="guid" width="300" height="100" />
  </v-sheet>
</template>

<script>
import { Chart } from "chart.js"
import moment from "moment";

export default {
  name: 'Report__WeeklyWorkHours',
  props: ['report_data', 'guid', 'name'],
  mounted() {
    this.canvas = document.getElementById(this.guid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      graph: null,
      canvas: null,
      weeks: [],
      indicators: [],
    }
  },
  methods: {
    make_chart: function() {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          data: {
            labels: this.weeks,
            datasets: [{
              label: "Человеко-часы",
              data: this.indicators,
              borderColor: '#d5a735',
              backgroundColor: '#d5a735',
            }]
          },
          options: {
            plugins: {
              legend: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      for (let i = 0; i < 12; i++) {
        this.weeks.push(moment().startOf('week').subtract(i, 'week').format('W'))
      }
      for (let i = 0; i < 12; i++) {
        let date = moment().startOf('week').subtract(i, 'week').format('YYYY-MM-DD[T]HH:mm:ss')
        let week = this.report_data.find(el => el.week === date)
        this.indicators.push(week ? week.indicator : 0)
      }

      this.weeks.reverse()
      this.indicators.reverse()
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>
